import React from "react"

export const MessageCTAModal = ({
  message_cta_modal_open,
  set_message_cta_modal_open,
}) => {
  const close_cta_modal = () => {
    set_message_cta_modal_open("")
  }
  return (
    <div className={`modal ${message_cta_modal_open}`}>
      <div
        className="modal-background"
        onClick={close_cta_modal}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="Close CTA Modal"
      ></div>
      <div className="modal-content">
        <div
          className="box mx-auto is-flex is-flex-direction-column"
          style={{ maxWidth: 530, minHeight: 350 }}
        >
          <p className="title is-5 mb-2 has-text-mitternachtsblau">
            Weiter nach Login
          </p>
          <hr className="is-mitternachtsblau-30 my-3" />
          <div
            className="has-text-mitternachtsblau mb-5 content"
            style={{ minHeight: 200 }}
          >
            <a
              href="https://auftragnehmer.bi-medien.de/de/home"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              Bitte loggen Sie sich ein oder erstellen Sie einen Account
            </a>
            , um eine Nachricht an den Auftraggeber zu schicken.
          </div>

          <button
            className="ml-auto is-tertiary button has-text-weight-bold"
            onClick={close_cta_modal}
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  )
}
